module.exports = __webpack_public_path__ + "img/Monaco.6852d9e3.svg";